module.exports = __webpack_public_path__ + "fonts/ufonts.com_klavika-bold-opentype.3bf3d0ea.otf";